<ion-header collapse="fade" translucent="true">
  <ion-toolbar>
    <ion-title>{{ "ORDERS.ORDERS" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-menu-button />
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="px-2" mode="ios">
    <div class="flex items-center">
      <ion-searchbar
        mode="ios"
        class="max-w-[550px] w-full !p-0 !pe-1"
        [placeholder]="'COMMON.SEARCH' | translate"
        (ionChange)="handleSearchInput($event)"
        (ionClear)="handleSearchInput()"
        [value]="searchValue()"
      />
      <ion-button
        color="light"
        mode="ios"
        fill="solid"
        style="--border-radius: 10px; --shadow: 0px"
        class="aspect-square !w-[38px] !shadow-none me-1"
        (click)="reloadOrdersList()"
      >
        <ion-icon slot="icon-only" size="small" name="refresh"></ion-icon>
      </ion-button>
      <div class="relative">
        <ion-button
          id="popover-trigger-order-list"
          color="light"
          mode="ios"
          fill="solid"
          style="--border-radius: 10px; --shadow: 0px"
          class="aspect-square !w-[38px] !shadow-none"
        >
          <ion-icon slot="icon-only" size="small" name="filter"></ion-icon>
        </ion-button>
        @if (store.ordersListInput().status !== undefined) {
          <div class="absolute -end-0.5 top-0.5 size-2 rounded-full bg-red-500"></div>
        }
      </div>

      <ion-popover mode="ios" trigger="popover-trigger-order-list" triggerAction="click" [dismissOnSelect]="true">
        <ng-template>
          <ion-content class="p-6">
            <ion-item
              lines="none"
              class="cursor-pointer hover:bg-medium/10"
              (click)="store.ordersListPage({ status: undefined })"
            >
              <ion-label>{{ "COMMON.ALL" | translate }}</ion-label>
              @if (!store.ordersListInput().status) {
                <ion-icon slot="end" color="success" size="small" name="checkmark-circle"></ion-icon>
              }
            </ion-item>
            @for (status of orderStatusList; track $index) {
              <ion-item
                lines="none"
                class="cursor-pointer hover:bg-medium/10"
                (click)="store.ordersListPage({ status })"
              >
                <mtjr-order-status-text [status]="status" />
                @if (store.ordersListInput().status === status) {
                  <ion-icon slot="end" color="success" size="small" name="checkmark-circle"></ion-icon>
                }
              </ion-item>
            }
          </ion-content>
        </ng-template>
      </ion-popover>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="scroll-visible">
  @switch (store.ordersListState().type) {
    @case ("loading") {
      <mtjr-loading />
    }
    @case ("error") {
      <mtjr-error [failure]="store.ordersFailure()" />
    }
    @case ("success") {
      <ion-list class="flex justify-center bg-transparent">
        <div class="h-full w-full max-w-[750px] items-center pb-6">
          @for (order of store.splitedOrders(); track $index) {
            <ion-card class="my-2 p-4" [routerLink]="[order.id, order.subOrders[0].id]">
              @for (subOrder of order.subOrders; track $index) {
                <div class="mb-1 flex items-center">
                  <div class="flex flex-1 flex-col">
                    <ion-text>{{ "ORDERS.ORDER_ID" | translate }}</ion-text>
                    <ion-text color="dark" class="text-lg">{{ order.orderNo }}</ion-text>
                  </div>
                  @if (!order.external) {
                    <ion-icon class="mx-2 text-lg" [name]="order.paymentMethod"></ion-icon>
                    <ion-text color="dark" class="font-bold">
                      {{ "ENUMS.PaymentMethod." + order.paymentMethod | translate }}
                    </ion-text>
                  } @else {
                    <ion-icon class="mx-2 text-lg" name="pencil-outline"></ion-icon>
                    <ion-text color="dark" class="font-bold">
                      {{ "ORDERS.EXTERNAL_ORDER" | translate }}
                    </ion-text>
                  }
                  <div class="bg-medium/30 h-4 w-[1px] mx-4"></div>
                  <ion-text color="primary" class="text-lg font-bold">{{ subOrder.total | vxCurrency }}</ion-text>
                </div>
                <div class="bg-light h-[1px] w-full"></div>
                <div class="mt-2 flex items-center">
                  <ion-text color="medium" class="me-2">{{ "COMMON.DATE" | translate }}:</ion-text>
                  <ion-text color="medium" class="flex-1">{{ order.createdAt | date: "yyyy-MM-dd" }}</ion-text>
                  <ion-text color="medium" class="me-2 text-sm">{{ "COMMON.STATUS" | translate }}</ion-text>
                  <mtjr-order-status-text [status]="subOrder.status"></mtjr-order-status-text>
                </div>

                <div class="mt-4 flex">
                  @for (item of subOrder.orderProducts.slice(0, 4); track $index) {
                    <mtjr-img
                      [src]="
                        item.productImage ??
                        item.variationImage ??
                        'https://nbg1.your-objectstorage.com/mtjr-prod/product-placeholder.webp'
                      "
                      [imgClass]="
                        'w-12 aspect-square rounded-lg p-[0.2px] border border-solid border-medium/30 me-2 ' +
                        (item.productType === 'digital' ? 'object-contain' : 'object-cover')
                      "
                      alt="{{ 'PRODUCTS.PRODUCT_IMAGE' | translate }}"
                    />
                  }
                  @if (subOrder.orderProducts.length > 4) {
                    <div class="border-medium/50 flex aspect-square w-12 rounded-lg border border-solid">
                      <ion-text color="primary" class="text-md m-auto">
                        +{{ subOrder.orderProducts.length - 4 }}
                      </ion-text>
                    </div>
                  }
                </div>
              }
            </ion-card>
          } @empty {
            <div class="flex w-full flex-col items-center justify-center">
              <mtjr-dynamic-img
                src="/assets/no_orders.svg"
                darkSrc="/assets/no_orders_dark.svg"
                class="size-[220px] opacity-80 dark:opacity-70"
              />
              <p class="text-medium/70 mt-2 text-center">{{ "ORDERS.NO_ORDERS" | translate }}</p>
            </div>
          }
        </div>
      </ion-list>
    }
  }
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
